module.exports = __webpack_public_path__ + "static/media/marron.63e128bb.png";